import { FC } from 'react'

type CloseIconProps = {
  onClick?: () => void
}

const CloseIcon: FC<CloseIconProps> = ({ onClick }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
      <path d="M15 15L10 10L15 5" stroke="#8C949C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 15L10 10L5 5" stroke="#8C949C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default CloseIcon
